// extracted by mini-css-extract-plugin
export default {"uploader":"uploader_uploader__GyYIY","uploader__icon":"uploader_uploader__icon__wn+xK"};